import { emailRegexp } from "$utils/utils";

export default {
  fields: [
    {
      formFields: [
        {
          type: "text",
          name: "lastname",
          className: "",
          label: "Nom",
          placeholder: "Tapez le nom du coordinateur",
          requiredText: "Veuillez remplir ce champ",
          regexText: "Veuillez saisir un nom valide",
          checkOnBlurRegex: "^[\\pM\\pLa-zA-ZÀ-ú ,.'-]+$",
          regex: "^[\\pM\\pLa-zA-ZÀ-ú ,.'-]+$",
        },
      ],
    },
    {
      formFields: [
        {
          type: "text",
          name: "firstname",
          className: "",
          label: "Prénom",
          placeholder: "Tapez le prénom du coordinateur",
          requiredText: "Veuillez remplir ce champ",
          regexText: "Veuillez saisir un prénoms valide",
          checkOnBlurRegex: "^[\\pM\\pLa-zA-ZÀ-ú ,.'-]+$",
          regex: "^[\\pM\\pLa-zA-ZÀ-ú ,.'-]+$",
        },
      ],
    },
    {
      formFields: [
        {
          type: "text",
          name: "email",
          className: "",
          label: "E-mail",
          placeholder: "Tapez l'e-mail du coordinateur",
          requiredText: "Veuillez remplir ce champ",
          regexText: "Veuillez saisir une adresse e-mail valide",
          regex: emailRegexp.toString(),
          checkOnBlurRegex: emailRegexp.toString(),
        },
      ],
    },
    {
      formFields: [
        {
          type: "text",
          name: "phone",
          className: "",
          label: "Téléphone",
          placeholder: "Tapez le téléphone du coordinateur",
          regexText: "Veuillez saisir un numéro de téléphone valide",
          regex: "^([0-9]){1,10}$",
          checkRegexOnType: true,
          checkOnBlurRegex: "^([0-9]){10}$",
        },
      ],
    },
  ],
};
